import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Recipes from "./components/Recipes";
import RecipeDetail from "./components/RecipeDetail";
import Footer from "./components/Footer";
import Omeni from "./components/Omeni";
import AllRecipes from "./components/AllRecipes";


import Login from "./components/Login";
import AdminPanel from "./components/AdminPanel";
import AdminRoute from "./components/AdminRoute";

import Kontakt from "./components/Kontakt";
import Putovanja from "./components/Putovanja";
import TravelDetail from "./components/TravelDetail";
import Indeks from "./components/Indeks";
import CookieBanner from "./components/CookieBanner";
import PrivacyPolicy from "./components/PrivacyPolicy";

export default function App() {
  return (
    <div className="app-root">
      <Navbar />
      <main>
        <Routes>
          {/* JAVNO */}
          <Route path="/" element={<Home />} />
          <Route path="/putovanja" element={<Putovanja />} />
          <Route path="/putovanja/:id" element={<TravelDetail />} />
          <Route path="/indeks" element={<Indeks />} />
          <Route path="/o-meni" element={<Omeni />} />
          <Route path="/all-recipes" element={<AllRecipes />} />

          {/* RECEPTI */}
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/recipes/:id" element={<RecipeDetail />} />

          {/* LOGIN */}
          <Route path="/prijava" element={<Login />} />

          {/* ADMIN ZAŠTIĆENO */}
          <Route
            path="/admin/*"
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            }
          />

          {/* KONTAKT */}
          <Route path="/kontakt" element={<Kontakt />} />

          {/* PRIVACY POLICY */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
